/**
 * The conversion factor of a base unit: one base unit is one base unit. Stock is a whole count of the base unit,
 * so a unit with this factor reads a stock figure unchanged. The server applies the same rule in
 * `MeasurementUnit::factorForPair()`.
 */
const BASE_UNIT_FACTOR = 1 as const

export { BASE_UNIT_FACTOR }
